"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Filters = void 0;
var dom_interact_1 = require("../helpers/dom-interact");
var HotjarWrapper_1 = require("../helpers/HotjarWrapper");
var tracker_1 = __importDefault(require("../helpers/tracker"));
var AbstractFilters_1 = require("./AbstractFilters");
var StickyElement_1 = require("./StickyElement");
var EllipsisElement_1 = require("./EllipsisElement");
var TrackingTypes_1 = require("../helpers/TrackingTypes");
var GA4FilterTracker_1 = require("./GA4/GA4FilterTracker");
var scrollAnimationDuration = 200;
var Filters = /** @class */ (function (_super) {
    __extends(Filters, _super);
    function Filters(el, options) {
        var _this = _super.call(this, el, options) || this;
        _this.customEvents = [
            { name: 'click', queries: ['.js-filter-opener'], callback: function () { return _this.onOpenFiltersPanel(); } },
            { name: 'click', queries: ['.js-apply-filters'], callback: function () { return _this.onApplySelectedFilters(); } },
            { name: 'click', queries: ['.js-tab-opener'], callback: function (e) { return _this.onSelectFilterTab(e); } },
            {
                name: 'click',
                queries: ['.js-close-filter-panel', '.js-filters-overlay'],
                callback: function () { return _this.onCloseFiltersPanel(); },
            },
            { name: 'click', queries: ['.js-remove-filter'], callback: function (e) { return _this.onFilterRemoveClick(e); } },
            { name: 'click', queries: ['.js-tab-content .js-label-toggle'], callback: function (e) { return _this.onFilterLabelClick(e); } },
        ];
        _this.desktopFilterPanelScroll = { left: 0, top: 0 };
        _this.mobileActiveFilterScroll = { left: 0, top: 0 };
        _this.isFilterPanelOpened = false;
        var selectedFiltersHolder = (0, dom_interact_1.getHTMLElement)(el, '.js-selected-filter-options-holder');
        _this.options = options;
        _this.stickyOpenButton = new StickyElement_1.StickyElement(_this.filterHolder, StickyElement_1.StickyPosition.TOP);
        _this.ellipsisElement = new EllipsisElement_1.EllipsisElement(selectedFiltersHolder, 16);
        _this.activeTabId = _this.getActiveTabId();
        _this.setAppliedFilterTabs();
        return _this;
    }
    Filters.prototype.onFilterItemClick = function (e) {
        var target = e.target;
        var currentTarget = e.currentTarget;
        var filterType = currentTarget.getAttribute('data-facet');
        var filterValue = (0, dom_interact_1.getAttributeFromTargetBubblingUpTo)('data-facet-item', target, currentTarget);
        if (!filterType) {
            throw new Error('Filter type not found in element');
        }
        // If no value is because clicked on the container and not in a filter value
        if (!filterValue) {
            return;
        }
        this.saveVisualStateOfOpenFilters(currentTarget);
        var isFilterBeingUsed = this.isFilterBeingUsed(filterType, filterValue);
        this.updateFiltersBeingUsed(filterType, filterValue, isFilterBeingUsed);
        this.sendRequest();
        GA4FilterTracker_1.GA4FilterTracker.trackFilterInteraction(this.options.trackingCategory, filterValue);
        this.trackClickOnFilterValue(filterType, filterValue, isFilterBeingUsed);
    };
    Filters.prototype.onFilterLabelClick = function (e) {
        var target = e.target;
        var nextSiblingContainer = target.nextElementSibling;
        if (nextSiblingContainer === null || nextSiblingContainer === void 0 ? void 0 : nextSiblingContainer.classList.contains('hide')) {
            nextSiblingContainer.classList.remove('hide');
            target.classList.remove('closed');
        }
        else if (nextSiblingContainer) {
            nextSiblingContainer.classList.add('hide');
            target.classList.add('closed');
        }
    };
    Filters.prototype.onFilterRemoveClick = function (e) {
        var target = e.target;
        var filterType = target.getAttribute('data-filter-type');
        var filterValue = target.getAttribute('data-filter-value');
        if (!filterType || !filterValue) {
            throw new Error('Filter type or filter value not found in element');
        }
        this.updateFiltersBeingUsed(filterType, filterValue, true);
        this.sendRequest();
        this.trackClickOnFilterRemove(filterType, filterValue);
    };
    Filters.prototype.onOpenFiltersPanel = function () {
        this.openFiltersPanel();
        this.trackOpenFiltersPanel();
    };
    Filters.prototype.onApplySelectedFilters = function () {
        this.closeFiltersPanel();
        this.trackApplySelectedFilters();
    };
    Filters.prototype.onCloseFiltersPanel = function () {
        this.closeFiltersPanel();
        this.trackCloseFiltersPanel();
    };
    Filters.prototype.onSelectFilterTab = function (event) {
        var tabElement = event.currentTarget;
        var tabContentId = tabElement.getAttribute('data-tab-id');
        if (!tabContentId || tabContentId === this.activeTabId) {
            return;
        }
        this.activeTabId = tabContentId;
        this.setActiveTab(tabElement);
        this.trackClickOnFilterTab();
    };
    Filters.prototype.openFiltersPanel = function () {
        this.isFilterPanelOpened = true;
        this.filterHolder.classList.add('is-open');
        document.body.classList.add('is-desktop-page-fixed');
        // start IE 11 fix
        var ie11FixElementList = document.querySelectorAll('.js-portrait-category-item-ie11-fix');
        for (var i = 0; i < ie11FixElementList.length; i++) {
            ie11FixElementList[i].classList.add('is-open-ie11-fix');
        }
        // end IE 11 fix
        (0, HotjarWrapper_1.hotJarTrigger)('filters-panel-open');
    };
    Filters.prototype.closeFiltersPanel = function () {
        this.isFilterPanelOpened = false;
        this.filterHolder.classList.remove('is-open');
        document.body.classList.remove('is-desktop-page-fixed');
        // start IE 11 fix
        var ie11FixElementList = document.querySelectorAll('.js-portrait-category-item-ie11-fix');
        for (var i = 0; i < ie11FixElementList.length; i++) {
            ie11FixElementList[i].classList.remove('is-open-ie11-fix');
        }
        // end IE 11 fix
        (0, HotjarWrapper_1.hotJarTrigger)('filters-panel-closed');
    };
    Filters.prototype.errorRequestCallback = function () {
        this.closeFiltersPanel();
    };
    Filters.prototype.rerenderFiltersCallback = function () {
        this.resetActiveTabs();
        (0, dom_interact_1.getHTMLElement)(this.el, "#".concat(this.activeTabId)).classList.add('is-active');
        (0, dom_interact_1.getHTMLElement)(this.el, ".js-tab-opener[data-tab-id=".concat(this.activeTabId, "]")).classList.add('is-active');
        this.filterHolder = (0, dom_interact_1.getHTMLElement)(this.el, '.js-filter-holder');
        if (this.isFilterPanelOpened) {
            this.openFiltersPanel();
            this.restoreVisualStateOfOpenFilters();
        }
        (0, dom_interact_1.scrollPageTo)((0, dom_interact_1.getPositionRelativeToDocument)(this.el).top, scrollAnimationDuration);
        this.stickyOpenButton.setElement(this.filterHolder);
        this.setAppliedFilterTabs();
        var ellipsisElementNewMarkup = (0, dom_interact_1.getHTMLElement)(this.el, '.js-selected-filter-options-holder');
        this.ellipsisElement.updateRootElement(ellipsisElementNewMarkup);
    };
    Filters.prototype.saveVisualStateOfOpenFilters = function (currentTarget) {
        var desktopScrollbarArea = (0, dom_interact_1.getHTMLElement)(this.el, '.js-filters-set');
        var mobileScrollbarArea = (0, dom_interact_1.getHTMLElement)(currentTarget, '.js-scrollbar-area');
        // Save scrolled position of filter panel on desktop
        this.desktopFilterPanelScroll = { left: desktopScrollbarArea.scrollLeft, top: desktopScrollbarArea.scrollTop };
        // Save scrolled position of active filter on mobile
        this.mobileActiveFilterScroll = { left: mobileScrollbarArea.scrollLeft, top: mobileScrollbarArea.scrollTop };
    };
    Filters.prototype.restoreVisualStateOfOpenFilters = function () {
        var desktopScrollbarArea = (0, dom_interact_1.getHTMLElement)(this.el, '.js-filters-set');
        var mobileScrollbarArea = (0, dom_interact_1.getHTMLElement)(this.el, "#".concat(this.activeTabId, " .js-scrollbar-area"));
        if (typeof document.body.scroll === 'function') {
            desktopScrollbarArea.scroll(this.desktopFilterPanelScroll);
            mobileScrollbarArea.scroll(this.mobileActiveFilterScroll);
        }
        else {
            // Special handle for IE<=11 (since IE11 is not mobile there is no need to change the element .js-scrollbar-area)
            desktopScrollbarArea.scrollTop = this.desktopFilterPanelScroll.top;
        }
    };
    Filters.prototype.setActiveTab = function (tabElement) {
        var contentElement = (0, dom_interact_1.getHTMLElement)(this.el, "#".concat(this.activeTabId));
        this.resetActiveTabs();
        tabElement.classList.add('is-active');
        contentElement.classList.add('is-active');
    };
    Filters.prototype.getActiveTabId = function () {
        return (0, dom_interact_1.getHTMLElement)(this.el, '.js-tab-content.is-active').id;
    };
    Filters.prototype.resetActiveTabs = function () {
        var activeTabsAndContainers = this.el.querySelectorAll('.is-active');
        for (var i = 0; i < activeTabsAndContainers.length; i++) {
            activeTabsAndContainers[i].classList.remove('is-active');
        }
    };
    Filters.prototype.setAppliedFilterTabs = function () {
        var filterTabs = this.el.querySelectorAll('.js-tab-opener');
        var currentlyAppliedFilterTypes = Object.keys(this.filtersBeingUsed);
        for (var i = 0; i < filterTabs.length; i++) {
            var tab = filterTabs[i];
            var filterType = tab.getAttribute('data-filter-name');
            if (filterType && ~currentlyAppliedFilterTypes.indexOf(filterType)) {
                dom_interact_1.cssClass.add(tab, ['is-applied']);
            }
            else {
                dom_interact_1.cssClass.remove(tab, ['is-applied']);
            }
        }
    };
    Filters.prototype.trackClickOnFilterRemove = function (filterType, filterValue) {
        tracker_1.default.track({
            category: this.options.trackingCategory,
            action: "filter_remove_".concat(filterType),
            label: filterValue,
        });
    };
    Filters.prototype.trackOpenFiltersPanel = function () {
        tracker_1.default.track({
            category: this.options.trackingCategory,
            action: TrackingTypes_1.TrackingData.ACTION_FILTER_OPEN_PANEL,
        });
    };
    Filters.prototype.trackCloseFiltersPanel = function () {
        tracker_1.default.track({
            category: this.options.trackingCategory,
            action: TrackingTypes_1.TrackingData.ACTION_FILTER_CLOSE_PANEL,
        });
    };
    Filters.prototype.trackClickOnFilterTab = function () {
        tracker_1.default.track({
            category: this.options.trackingCategory,
            action: TrackingTypes_1.TrackingData.ACTION_FILTER_TAB_CLICK,
            label: this.activeTabId,
        });
    };
    Filters.prototype.trackApplySelectedFilters = function () {
        tracker_1.default.track({
            category: this.options.trackingCategory,
            action: TrackingTypes_1.TrackingData.ACTION_FILTER_RESULTS_CLICK,
        });
    };
    return Filters;
}(AbstractFilters_1.AbstractFilters));
exports.Filters = Filters;
